<template>
  <div id="header-mobile">
    <div class="header-mobile-left">
      <i class="mobile-menu-icon" v-if="$route.name == 'home'" @click="drawer = !drawer"></i>
      <i class="fas fa-arrow-left" :key="routeNameKey" v-else @click="goPath"></i>
    </div>
    <div class="header-mobile-right">
      <div class="not-login" v-if="$store.state.user == null">
        <div class="not-login-button" @click="goLogin">
          <i class="fas fa-sign-in-alt"></i>
          <span>{{ $t("loginText") }}</span>
        </div>
      </div>
      <div class="login-area" v-else>
        <div class="login-area-item" @click.stop="$root.$emit('MessagesDialogModal')">
          <i class="fas fa-comments"></i>
        </div>
        <div class="login-area-item" @click.stop="$root.$emit('NotificationsDialogModal')">
          <i class="fas fa-bell"></i>
        </div>
        <div class="login-area-item profile" @click.stop="$root.$emit('accountSettingsModal')">
          <img :src="$store.state.user.image" alt="User Profile Image" />
        </div>
      </div>
    </div>
    <el-drawer append-to-body title="I am the title" width="70%" :visible.sync="drawer" custom-class="mobile-drawer" direction="ltr">
      <div class="mobile-drawer-header">
        <img v-if="$route.params.slug != 'holacon'" :src="$imageus + $store.state.application.image + '?width=200&height=200)'" class="logo wlabel" style="cursor: pointer" :style="getHeaderClass == 'dark' ? 'height: 42px' : 'width: 180px; box-shadow:0px 2px 10px rgba(41, 47, 59, 0.1);'" @click="$router.push({ name: 'events' })" />
        <img v-else :src="getHeaderClass == 'dark' ? '/static/logo_white.svg' : '/static/logo.svg'" class="logo" style="cursor: pointer" :style="getHeaderClass == 'dark' ? 'height: 42px' : 'width: 180px;'" @click="$router.push({ name: 'events' })" />
      </div>
      <div class="mobile-drawer-body">
        <div class="mobile-menu-area">
          <div class="mobile-menu-item">
            <div class="mobile-menu-item-title">{{ $t("account_settings.account.title") }}</div>
            <div class="mobile-menu-item-account" v-if="$store.state.user != null" @click="$root.$emit('accountSettingsModal')">
              <img :src="$store.state.user.image != null ? $store.state.user.image : '/static/Circle.svg'" alt="" />
              <div class="mobile-menu-item-account-text">
                <span class="fullName">{{ $store.state.user.fullName }}</span>
                <span class="email">{{ $store.state.user.email }}</span>
              </div>
            </div>
            <div class="mobile-menu-item-account" v-else @click="goLogin">
              <img src="/static/Circle.svg" alt="Default User Mobile" />
              <div class="mobile-menu-item-account-text">
                <span class="not-login">{{ $t("welcome") }} <span class="colored">{{ $t("guestText") }}</span>,</span>
                <span class="not-login"><i class="fas fa-sign-in-alt colored"></i>{{ $t("loginText") }}</span>
              </div>
            </div>
          </div>
          <div class="mobile-menu-item" v-if="policies.length > 0">
            <div class="mobile-menu-item-title">{{ $t("legal") }}</div>
            <div class="mobile-menu-item-list">
              <div class="mobile-menu-item-list-item" v-if="policies.some(x => x.type == 12)" @click="openPolicy(12)">
                <div class="icon-box">
                  <i class="fas fa-file"></i>
                </div>
                <span>{{ $t("policies.termsOfUse") }}</span>
              </div>
              <div class="mobile-menu-item-list-item" v-if="policies.some(x => x.type == 11)"  @click="openPolicy(11)">
                <div class="icon-box">
                  <i class="fas fa-shield-alt"></i>
                </div>
                <span>{{ $t("policies.privacyPolicy") }}</span>
              </div>
              <div class="mobile-menu-item-list-item" v-if="policies.some(x => x.type == 13)"  @click="openPolicy(13)">
                <div class="icon-box">
                  <i class="fas fa-clipboard-list"></i>
                </div>
                <span>{{ $t("policies.kvkk") }}</span>
              </div>
            </div>
          </div>
          <div class="mobile-menu-item">
            <div class="mobile-menu-item-title">{{ $t("app") }}</div>
            <div class="mobile-menu-item-list">
              <div class="mobile-menu-item-list-item"  @click="goLink(currentApplication.androidLink != null ? currentApplication.androidLink : currentApplication.iosLink != null ?currentApplication.iosLink : currentApplication.whitelabelDomain )">
                <div class="icon-box">
                  <i class="fas fa-share"></i>
                </div>
                <span>{{ $t("recommendFriend") }}</span>
              </div>
              <div class="mobile-menu-item-list-item">
                <div class="icon-box">
                  <i class="fas fa-smile"></i>
                </div>
                <span>{{ $t("sendFeedback") }}</span>
              </div>
              <div class="mobile-menu-item-list-item" @click="goLink(currentApplication.androidLink != null ? currentApplication.androidLink : currentApplication.iosLink != null ?currentApplication.iosLink : currentApplication.whitelabelDomain )">
                <div class="icon-box">
                  <i class="fas fa-star"></i>
                </div>
                <span>{{ $t("rateUs") }}</span>
              </div>
              <div class="mobile-menu-item-list-item" @click="goLink('https://holacon.com/attendee-apps')">
                <div class="icon-box">
                  <img src="/static/mini-logo.svg" alt="">
                </div>
                <span>{{ $t("aboutApp") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-dialog :visible.sync="policyModal" class="default" :close-on-click-modal="false" append-to-body center destroy-on-close :title="policy.title">
      <div class="custom-modal" v-if="policy.details != null">
        <div class="modal-body no-footer" v-html="policy.details"></div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="accountSettingsModal" class="default" :close-on-click-modal="false" append-to-body center destroy-on-close :title="$t('account_settings.settings')">
      <AccountSettings @closeDialog="accountSettingsModal = false" />
    </el-dialog>

    <el-dialog :visible.sync="userProfileModal" class="medium" :close-on-click-modal="false" append-to-body center destroy-on-close :title="$t('account_settings.profile.title')">
      <UserProfileDialog @closeDialog="userProfileModal = false" />
    </el-dialog>

    <el-dialog :visible.sync="MessagesDialogModal" class="custom-messages-dialog" :class="innerWidth <= 768 ? 'mobile-dialog' : ''" :close-on-click-modal="false" append-to-body center destroy-on-close :title="$t('contacts_hub.title')">
      <MessagesDialog @closeDialog="MessagesDialogModal = false" v-if="MessagesDialogModal" />
    </el-dialog>

    <el-dialog :visible.sync="NotificationsDialogModal" class="default primary" :close-on-click-modal="false" append-to-body center destroy-on-close :title="$t('account_bar.notifications')">
      <NotificationsDialog @closeDialog="NotificationsDialogModal = false" v-if="NotificationsDialogModal" />
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import AccountSettings from "../components/AccountSettings";
import MessagesDialog from "../components/MessagesDialog";
import UserProfileDialog from "../components/UserProfileDialog";
import NotificationsDialog from "../components/NotificationsDialog";
export default {
  components: {
    AccountSettings,
    MessagesDialog,
    NotificationsDialog,
    UserProfileDialog
  },
  data() {
    return {
      policyModal: false,
      policy: {},
      policies: [],
      drawer: false,
      host: location.host == "localhost:3000" ? "https://live.holacon.com/" : "https://" + location.host,
      routeName: this.$route.name,
      routeNameKey: +new Date(),
      userProfileModal: false,
      accountSettingsModal: false,
      MessagesDialogModal: false,
      NotificationsDialogModal: false
    };
  },
  async created() {
    var policy = localStorage.getItem("policy");
    if (policy != undefined && policy != null) {
      this.policies = JSON.parse(policy);
    } else {
      var res = await this.$store.dispatch("getApplicationPolicies", this.currentApplication.id);
      this.policies = res.data.data.items;
      localStorage.setItem("policy", JSON.stringify(res.data.data.items));
    }
  },
  mounted() {
    if (this.$store.state.user != null) {
      this.$socket.emit("subscribe", {
        channel: "message-" + this.$store.state.user.id,
        token: ""
      });

      this.$socket.on("message-" + this.$store.state.user.id + "-newMessage", async data => {
        data = data.data;
        var index = this.$store.state.chats.findIndex(k => k.id == data.MessageGroupID);

        if (index != -1) {
          this.$store.state.chats[index].lastMessage.messageText = data.MessageText;
          this.$store.state.chats[index].lastMessage.createDate = data.CreateDate;
          this.$store.state.chats[index].lastMessageDate = data.CreateDate;
          this.$store.state.chats[index].lastMessageReceived = data.CreateDate;

          if (data.User.UserID != this.$store.state.user.id) {
            if (this.$store.state.activeChatPanelId != data.MessageGroupID) {
              this.$store.state.chats[index].unread += 1;
              this.$store.state.unreadMessages += 1;
            }
          }
        } else {
          var response = await axios.post("Chat/LoadMessageGroups", {
            skip: 0,
            take: 10
          });

          var data = [];

          response.data.data.items.map(i => {
            (i.minimized = true), (i.isActive = false), (i.messages = []);
            data.push(i);
          });

          this.$store.state.chats = data;
          this.$store.state.unreadMessages += 1;
        }
      });

      this.$socket.emit("subscribe", {
        channel: "private-" + this.$store.state.user.id,
        token: ""
      });

      this.$socket.on("private-" + this.$store.state.user.id + "-client-network-request", request => {
        if (request.eventID != axios.defaults.headers.eventID) {
          return;
        }
        this.networkRequestNotification = true;
        this.networkRequest = request;
        this.playSound();
      });

      this.$socket.on("private-" + this.$store.state.user.id + "-client-network-accept", request => {
        console.log(request);
      });
    }

    this.$root.$on("accountSettingsModal", () => {
      this.accountSettingsModal = true;
    });

    this.$root.$on("MessagesDialogModal", () => {
      this.MessagesDialogModal = true;
    });
    this.$root.$on("NotificationsDialogModal", () => {
      this.NotificationsDialogModal = true;
    });
    this.$root.$on("getProfile", id => {
      if(id == null) return;
      axios.get("profile/get?userID=" + id).then(res => {
        this.$store.state.currentUserProfile = res.data.data.item;
        this.$store.state.currentUserProfile.sameEvents = res.data.data.sameEvents.items;
        this.ProgramDetailDialogModal = false;
        this.MessagesDialogModal = false;
        this.userProfileModal = true;
      });
    });
  },
  beforeDestroy() {
    this.$root.$off("accountSettingsModal");
    this.$root.$off("MessagesDialogModal");
    this.$root.$off("NotificationsDialogModal");
    // this.$root.$off("ProgramDetailDialogModal");
    // this.$root.$off("SpeakerDetailDialogModal");
    this.$root.$off("getProfile");

    this.$socket.off("message-" + this.$store.state.user.id + "-newMessage");
    this.$socket.off("private-" + this.$store.state.user.id + "-client-network-request");
    this.$socket.off("private-" + this.$store.state.user.id + "-client-network-accept");
  },
  methods: {
    goLink(link){
      window.open(link, '_blank');
    },
    openPolicy(type) {
      this.policy = this.policies.find(x => x.type == type);
      if (this.policy == null) {
        this.$message.info("Sözleşme bulunamadı");
        return;
      }
      this.policyModal = true;
    },
    goLogin() {
      this.$router.push({ name: "login" }).catch(e => {});
    },
    goPath() {
      if (this.getMobileBackPath != null) {
        this.$router.push({ name: this.getMobileBackPath }).catch(e => {});
      } else if (this.$route.name == "event") {
        this.$router.push({ name: "home" }).catch(e => {});
      } else {
        this.$router.push({ name: "event" }).catch(e => {});
      }
    }
  },
  computed: {
    getHeaderClass() {
      if (this.routeName == "home" || this.routeName == "events" || this.routeName == "incomingevents" || this.routeName == "pastevents") {
        return "light";
      }
      return "dark";
    },
    innerWidth() {
      return window.innerWidth;
    },
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    currentApplication() {
      return this.$store.getters.getApplication;
    },
    getMobileBackPath() {
      return this.$store.getters.getMobileBackPath;
    }
  },
  watch: {
    "$route.name": function() {
      this.routeNameKey += 1;
    }
  }
};
</script>

<style lang="less">
#header-mobile {
  height: 50px;
  background: #e8ebef;
  box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
  overflow: hidden;
  position: fixed;
  z-index: 1000;
  width: 100%;
  overflow: hidden;
  top: 0;
  border-radius: 0px 0px 16px 16px;
  display: flex;
  padding: 9px 16px;
  align-items: center;
  display: flex;
  flex-direction: row;
  .header-mobile-left {
    text-align: center;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      margin-right: auto;
      cursor: pointer;
      font-size: 22px;
      color: #292f3b;
    }
    span {
      font-weight: 700;
      margin-right: auto;
      font-size: 18px;
      line-height: 24px;
    }
  }
  .header-mobile-right {
    flex-shrink: 0;
    & > .not-login {
      & > .not-login-button {
        border-radius: 8px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        font-size: 14px;
        background-color: white;
        cursor: pointer;
        padding: 8px 12px;
        line-height: 14px;
        font-weight: bold;

        i {
          color: #268ea6;
        }
      }
    }
    .login-area {
      display: flex;
      align-items: center;
      gap: 10px;
      .login-area-item {
        width: 32px;
        background: #f1f3f6;
        border-radius: 8px;
        display: flex;
        cursor: pointer;
        align-items: center;
        font-size: 18px;
        justify-content: center;
        height: 32px;
        &.profile {
          border-radius: 50%;
          overflow: hidden;
          border: 2px solid white;
        }
        & > img {
          object-fit: cover;
        }
      }
    }
  }
}
.mobile-drawer {
  width: 70vw !important;
  .el-drawer__header  {
    display: none !important;
  }
  .el-drawer__body {
    .mobile-drawer-header {
      display: flex;
      align-items: center;
      background: #f1f3f6;
      justify-content: center;
      padding: 1rem;
      img {
        border-radius: 12px;
      }
    }
    .mobile-drawer-body {
      padding: 24px 1rem;
      background: white;
      .mobile-menu-area {
        display: flex;
        flex-direction: column;
        color: #292f3b;
        gap: 24px;
        .mobile-menu-item {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          .mobile-menu-item-title {
            font-weight: 700;
            font-size: 14px;
            line-height: 20px;
          }
          .mobile-menu-item-list {
            display: flex;
            flex-direction: column;
            gap: 1rem;
            .mobile-menu-item-list-item {
              cursor: pointer;
              display: flex;
              flex-direction: row;
              gap: 8px;
              align-items: center;
              & > .icon-box {
                width: 24px;
                height: 24px;
                i {
                  font-size: 18px;
                  line-height: 24px;
                  color: #268ea6;
                }
                display: flex;
                align-items: center;
                justify-content: center;
              }
              & > span {
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #505763;
              }
            }
          }
          .mobile-menu-item-account {
            cursor: pointer;
            display: flex;
            gap: 10px;
            align-items: center;
            img {
              width: 48px;
              height: 48px;
              border-radius: 50%;
              flex-shrink: 0;
              object-fit: cover;
              border: 2px solid #e8ebef;
            }

            .mobile-menu-item-account-text {
              display: flex;
              flex-direction: column;
              gap: 2px;
              .not-login {
                font-weight: 600;
                font-size: 16px;
                line-height: 24px;
                color: #292f3b;

                & > i {
                  &::before {
                    color: #268ea6 !important;
                    margin: 0 0.2rem;
                  }
                }

                & > .colored {
                  color: #268ea6;
                }
              }
              .fullName {
                font-weight: 600;
                font-size: 16px;
                line-height: 24px;
                color: #292f3b;
              }
              .email {
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #505763;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/HeaderMobile.vue